'use strict';

angular.module('webAgro1App').factory('ColheitaService', function($http) {
  const post = function(url, params) {
    return $http.post(url, params);
  };

  const patch = function(url, params) {
    return $http.patch(url+params.colheita.id, params);
  };

  return {
    getQuantidadeColhida: function(params) {
      const url = `${SERVER + API_VERSION }colheitas`;

      return $http.get(url, { params: params });
    },

    list: function(filters) {
      const params = {
        id: filters.id,
        propriedade: (filters.propriedade || {}).id,
        safra: (filters.safra || {}).id,
        atividade: (filters.atividade || {}).id,
        gleba: (filters.gleba || {}).id
      };

      const url = `${SERVER + API_VERSION }ino_colheitas`;
      return $http.get(url, { params: params });
    },

    get: function(id) {
      const url = `${SERVER + API_VERSION }ino_colheitas/${ id}`;
      return $http.get(url);
    },

    delete: function(id) {
      const url = `${SERVER + API_VERSION }ino_colheitas/${ id}`;
      return $http.delete(url);
    },

    save: function(colheita) {
      const url = `${SERVER + API_VERSION }ino_colheitas/`;
      const httpMethod = colheita.id ? patch : post;

      const params = {
        colheita: {
          id: colheita.id,
          atividade_id: colheita.atividade.id,
          gleba_id: colheita.gleba.gleba.id,
          safra_id: colheita.safra.id,
          insumo_tipo: colheita.insumo.tipo_item,
          insumo_id: colheita.insumo.item_id,
          data_inicio: colheita.data_inicio,
          data_termino: colheita.data_termino,
          area_total_ha: colheita.area_total_ha,
          total_colhido_kg: colheita.total_colhido_kg,
          atr_medio: colheita.atr_medio,
          change_corte: colheita.change_corte ? colheita.change_corte : null
        }
      };

      return httpMethod(url, params);
    }
  };
});
